// Only fixed event names; never send form values, URLs or identifying payloads.
export const track = (event) => window.x1025Analytics?.track(event);
